import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useGetPickupZones } from "@/api/pickupZones.api";
import { CollectionParametersHeader } from "@/components/backOffice/collectionParameters/collectionParametersHeader";
import { CollectionZoneElem } from "@/components/backOffice/collectionParameters/collectionZoneElem";
import { CollectionZoneEditModal } from "@/components/backOffice/collectionParameters/collectionZoneEditModal";
import { PickupZone } from "@/types/api/api-types";

export const CollectionParametersPage = () => {
  const { t } = useTranslation("boLogistics");
  const [editingZone, setEditingZone] = useState<PickupZone | null | undefined>(undefined);

  const { data: pickupZones } = useGetPickupZones();

  const closeModal = () => setEditingZone(undefined);

  return (
    <div className="flex h-fit w-full flex-1 flex-col gap-8 p-8">
      <CollectionParametersHeader />
      <div className="flex flex-1 flex-col items-center gap-6">
        <div className="flex w-full max-w-[600px] flex-col gap-2 rounded-xl border border-gray-200 bg-white p-6">
          <h4 className="text-sm font-semibold text-black">
            {t("collectionParametersPage.zonesTitle")}
          </h4>
          <div className="flex flex-col gap-2">
            {pickupZones && pickupZones.length > 0
              ? pickupZones.map((zone) => (
                  <CollectionZoneElem key={zone.id} zone={zone} handleEdit={setEditingZone} />
                ))
              : t("collectionParametersPage.zonesEmpty")}
          </div>
          <button
            onClick={() => setEditingZone(null)}
            className="border-lg bg-brand50 text-brand700 hover:border-brand700 hover:text-brand600 w-fit self-center border border-transparent px-3 py-2 font-semibold"
          >
            {t("collectionParametersPage.addZone")}
          </button>
        </div>
      </div>
      <CollectionZoneEditModal
        open={editingZone !== undefined}
        onClose={closeModal}
        zone={editingZone ?? null}
      />
    </div>
  );
};
